module.exports = __webpack_public_path__ + "static/media/one.33194abf.svg";